export default __webpack_public_path__ + "static/media/img-8.3a201bd0.jpg";